import PropTypes from 'prop-types';
import React from 'react';

import Result from './result';
import ResultDetailed from './result_detailed';
import ResultSimple from './result_simple';
import ResultFlex from './result_flex';
import ResultBar from './result_bar';

export default function ResultSelector(props) {
  const {
    result,
    settings,
  } = props;

  switch (settings.resultType) {
  case 'flex':
    return (
      <ResultFlex
        key={result.lngProductId}
        result={result}
        settings={settings}
      />
    );
  case 'simple':
    return (
      <ResultSimple
        key={result.lngProductId}
        result={result}
        settings={settings}
      />
    );
  case 'detailed':
    return (
      <ResultDetailed
        key={result.lngProductId}
        result={result}
        settings={settings}
      />
    );
  case 'bar':
    return (
      <ResultBar
        key={result.lngProductId}
        result={result}
        settings={settings}
      />
    );
  default:
    return (
      <Result
        key={result.lngProductId}
        result={result}
        settings={settings}
      />
    );
  }
}

ResultSelector.propTypes = {
  result: PropTypes.shape({
    strProductName: PropTypes.string,
    strMerchantName: PropTypes.string,
    lngProductId: PropTypes.string,
    dblProductSalePrice: PropTypes.string,
  }).isRequired,
  settings: PropTypes.shape({
    resultRender: PropTypes.func,
    resultType: PropTypes.string,
  }).isRequired,
};
